import ContactCompletedLp from './ContactCompletedLp'

export default ContactCompletedLp
